<div class="bs-pol-enrolled">
    <div class="bs-card-header">
        <div class="bs-card-title">
            <div>{{"You have already enrolled in paperless "}}</div>
            <div>{{"for this policy."}}</div>
        </div>
        <div class="bs-card-desc">
            {{"If you have any questions or you didn’t make this change contact our"}} <span><a href="https://www.mapfreinsurance.com/contact/" target="_blank" class="mapfre link stuffer-underline red-link dm-sans-medium ">{{"customer service department"}}</a></span>.
        </div>
    </div>   
     <app-sustainability-card></app-sustainability-card>
</div>